import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import APIHandler from 'config/APIHandler';

export interface ImpersonationPreviewInput {
  appId: string;
  token: string;
}

function isValidPreviewUser(res: unknown): res is Record<string, unknown> & { email: string } {
  return typeof res === 'object' && res !== null && typeof (res as { email?: unknown }).email === 'string';
}

/** Fetches the target user's profile with a freshly-issued impersonation token, before committing to the swap. */
export function useImpersonationPreview(): UseMutationResult<
  Record<string, unknown>,
  Error,
  ImpersonationPreviewInput
> {
  return useMutation({
    mutationFn: async ({ appId, token }: ImpersonationPreviewInput): Promise<Record<string, unknown>> => {
      const res = (await APIHandler.getUser(appId, token)) as unknown;

      if (!isValidPreviewUser(res)) {
        throw new Error('Failed to fetch user profile for impersonation');
      }

      return res;
    },
  });
}
